// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"147":"2f20c72f","165":"79b2bbec"}[chunkId] + ".chunk.css";
};